import './styles/MemberHome.scss';
import { App_ViewModeMap, Events_PageMap, System_DeviceOrientationMap } from '../../assets/keyMap';
import { AppContext, ExAppContext } from '../../Context';
import { useContext, useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router';
import { IonDate, IonDateString, IonDateFormat } from '../../components/IonDate';
import { Browser } from '@capacitor/browser';
import { ErrorLogger as elog, DebugLogger as dlog } from '../../components/Logger';
import axios from 'axios';

//classes
import Event from '../../exClasses/event';
import SlideProfile from '../../classes/slideProfile';
import Document from '../../exClasses/document';
import Notice from '../../classes/notice';

//components
import SlideProjector from '../../components/SlideProjector';
import NoticeBoard from '../../components/NoticeBoard';
// import ImageCropper from '../../components/ImageCropper';

//controllers
// import InfinityEncryptor from '../../plugins/InfinityEncryptor';
import DatabaseInterfaceController from '../../controllers/DatabaseInterfaceController';

//handlers
import SwipeOverscrollHandler from '../../handlers/SwipeOverscrollHandler';

//mui icons
// import MovieIcon from '@mui/icons-material/Movie';
// import CelebrationIcon from '@mui/icons-material/Celebration';
// import BurstModeIcon from '@mui/icons-material/BurstMode';
// import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DateRangeIcon from '@mui/icons-material/DateRange';
import EastIcon from '@mui/icons-material/East';
// import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
// import PanoramaIcon from '@mui/icons-material/Panorama';
// import EditNoteIcon from '@mui/icons-material/EditNote';
// import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

//graphics
// import CertificateIcon from '../../assets/images/icons/certificateIcon.png';
// import ViewIcon from '../../assets/images/icons/viewIcon.png';
// import PPKMLogo from '../../assets/images/logos/ppkmLogo.jpg';
// import Portrait from '../../assets/images/logos/portrait.jpg';
// import LicenceIcon from '../assets/images/icons/licenceIcon.png';
import DefaultImage from '../../assets/images/general/defaultImage.jpg';
import { isPlatform } from '@ionic/react';

class NewsletterImgMap {
    documentID: string = '';
    src: string = '';
};

interface Props {
}

const MemberHome: React.FC<Props> = ({ }) => {
    //contexts
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    // //states
    // const [navigatedEventIndex, SetNavigatedEventIndex] = useState(0);
    const [topMargin, SetTopMargin] = useState(0); //px //special top margin adjusted according to screen ratio
    const [highlights, SetHighlights] = useState<SlideProfile[]>([] as SlideProfile[]);
    const [upcomingEvents, SetUpcomingEvents] = useState<Event[]>([] as Event[]);
    const [pastEvents, SetPastEvents] = useState<Event[]>([] as Event[]);
    const [myEventsAltImgs, SetMyEventsAltImgs] = useState([] as string[]);
    const [upcomingEventsAltImgs, SetUpcomingEventsAltImgs] = useState([] as string[]);
    const [pastEventsAltImgs, SetPastEventsAltImgs] = useState([] as string[]);
    const [newslettersYears, SetNewslettersYears] = useState([] as string[]);
    const [newsletters, SetNewsletters] = useState([] as Document[]);
    const [newslettersAltImgs, SetNewslettersAltImgs] = useState([] as NewsletterImgMap[]);
    const [notices, SetNotices] = useState([] as Notice[]);
    //refs
    // const navigatedEventIndexRef = useRef<number>(navigatedEventIndex);
    const upcomingEventsAltImgsRef = useRef<string[]>(upcomingEventsAltImgs);
    const pastEventsAltImgsRef = useRef<string[]>(pastEventsAltImgs);
    const myEventsAltImgsRef = useRef<string[]>(myEventsAltImgs);
    const newslettersAltImgsRef = useRef<NewsletterImgMap[]>(newslettersAltImgs);
    const homeScrollerRef = useRef<any>(null);
    //router objs
    const history = useHistory();
    //controllers
    // const infinityEncryptor = new InfinityEncryptor('23456');
    const databaseInterfaceController = new DatabaseInterfaceController(appContext);

    //test
    // useEffect(() => {
    //     console.log('MemberHomeTest: ' + JSON.stringify(appContext.databaseActionModeQueue));
    // }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);
    useEffect(() => {
        console.log('MemberHomeTest: ' + JSON.stringify(appContext.user));
    }, [appContext.user]);

    //watchers
    //initialize
    useEffect(() => {
        //adjust top margin
        // if(isPlatform('ios')) {
        //     SetTopMargin(window.innerHeight * (-0.1));
        // } else {
        //     SetTopMargin(window.innerHeight * (0.01));
        // }

        //
        requestAnimationFrame(() => {
            //check is user empty, on page refresh user is empty
            if(Object.keys(appContext.user).length > 0) {
                //fetch highlights
                databaseInterfaceController.Queue('fetchHighlightProfiles', [
                    ['fetchHighlightProfiles', 'true']
                ]);
                // //fetch upcomingEvents
                databaseInterfaceController.Queue('fetchUpcomingEvents', [
                    ['fetchUpcomingEvents', 'true'],
                    ['dateNow', IonDateString(new Date())]
                ]);
                // //fetch latestPastEvents
                databaseInterfaceController.Queue('fetchLatestPastEvents', [
                    ['fetchLatestPastEvents', 'true'],
                    ['dateNow', IonDateString(new Date())]
                ]);
                // //fetch newsLetters
                const dateNow = new Date();
                const previousYear = dateNow.getFullYear() - 1;
                databaseInterfaceController.Queue('fetchCurrentNewsletters', [
                    ['fetchCurrentNewsletters', 'true'],
                    ['previousYear', previousYear.toString()]
                ]);

                //fetch noticeBoard
                if (appContext.shouldShowNotices)
                    FetchAndShowNotices();
            }
        });
    }, []);

    //watch for navigatedEventIndex update reset altImg
    // useEffect(() => {
    //     SetMyEventsAltImg('');
    // }, [navigatedEventIndex]); ---deprecated

    //watch for userUpcomingEventsUpdated reset myEventsAltImg
    useEffect(() => {
        myEventsAltImgsRef.current = [] as string[];
        exAppContext.userUpcomingEvents.map((event: Event) => {
            myEventsAltImgsRef.current.push('');
        });
        SetMyEventsAltImgs([...myEventsAltImgsRef.current]);
    }, [exAppContext.userUpcomingEvents]);

    //watch for upcomingEventsUpdated reset upcomingEventsAltImg
    useEffect(() => {
        upcomingEventsAltImgsRef.current = [] as string[];
        upcomingEvents.map((event: Event) => {
            upcomingEventsAltImgsRef.current.push('');
        });
        SetUpcomingEventsAltImgs([...upcomingEventsAltImgsRef.current]);
    }, [upcomingEvents]);

    //watch for pastEventsUpdated reset pastEventsAltImgs
    useEffect(() => {
        pastEventsAltImgsRef.current = [] as string[];
        pastEvents.map((event: Event) => {
            pastEventsAltImgsRef.current.push('');
        });
        SetPastEventsAltImgs([...pastEventsAltImgsRef.current]);
    }, [pastEvents]);

    //watc for( newsletters reset newslettersAltImgs
    useEffect(() => {
        newslettersAltImgsRef.current = [] as NewsletterImgMap[];
        newsletters.map((newsletter: Document) => {
            newslettersAltImgsRef.current.push({ documentID: newsletter.documentID, src: '' } as NewsletterImgMap);
        });
        SetNewslettersAltImgs([...newslettersAltImgsRef.current]);
    }, [newsletters]);

    //watch  for database result actions
    useEffect(() => {
        if (appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction != null) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();
                switch (mode) {
                    case 'fetchHighlightProfiles':
                        let resArr = [] as any;
                        try {
                            resArr = JSON.parse(res) as any[];
                        } catch {
                            resArr = res as any[];
                        }
                        const _highlights = [] as SlideProfile[];
                        if (resArr.length > 0) {
                            resArr.map((resObj: any) => {
                                _highlights.push(new SlideProfile(
                                    resObj['src'], resObj['action']
                                ))
                            });
                        }
                        SetHighlights([..._highlights]);
                        break;
                    case 'fetchUpcomingEvents':
                        if (!JSON.stringify(res).includes('_false')) {
                            let jsonObjs = [] as any[];
                            try {
                                jsonObjs = JSON.parse(res) as any[];
                            } catch {
                                jsonObjs = res as any[];
                            }
                            if (jsonObjs.length > 0) {
                                const _upcomingEvents = [] as Event[];
                                jsonObjs.map((obj: any) => {
                                    _upcomingEvents.push(new Event(
                                        obj['eventID'],
                                        obj['event_categoryID'],
                                        obj['event_name'],
                                        obj['event_name_highlight_texts'],
                                        obj['event_name_highlight_colors'],
                                        obj['event_desc'],
                                        obj['event_poster'],
                                        obj['event_file'],
                                        obj['event_venue'],
                                        obj['registration_start_date'],
                                        obj['registration_end_date'],
                                        obj['early_bird_start_date'],
                                        obj['early_bird_end_date'],
                                        obj['event_start_date'],
                                        obj['event_end_date'],
                                        obj['event_schedules'],
                                        obj['max_pax'],
                                        obj['hostID'],
                                        obj['datetime_created'],
                                        obj['datetime_updated'],
                                        obj['inapp_registration'],
                                        obj['external_registration_link']
                                        // obj['attachment_base_url'],
                                        // obj['attachment_file_names']
                                    ))
                                });
                                SetUpcomingEvents([..._upcomingEvents]);
                            }
                        }
                        break;
                    case 'fetchLatestPastEvents':
                        if (!JSON.stringify(res).includes('_false')) {
                            const _pastEvents = [] as Event[];
                            let resObjs = [] as any[];
                            try {
                                resObjs = JSON.parse(res) as any[];
                            } catch {
                                resObjs = res as any[];
                            }
                            if (resObjs.length > 0) {
                                resObjs.map((obj: any) => {
                                    _pastEvents.push(new Event(
                                        obj['eventID'],
                                        obj['event_categoryID'],
                                        obj['event_name'],
                                        obj['event_name_highlight_texts'],
                                        obj['event_name_highlight_colors'],
                                        obj['event_desc'],
                                        obj['event_poster'],
                                        obj['event_file'],
                                        obj['event_venue'],
                                        obj['registration_start_date'],
                                        obj['registration_end_date'],
                                        obj['early_bird_start_date'],
                                        obj['early_bird_end_date'],
                                        obj['event_start_date'],
                                        obj['event_end_date'],
                                        obj['event_schedules'],
                                        obj['max_pax'],
                                        obj['hostID'],
                                        obj['datetime_created'],
                                        obj['datetime_updated'],
                                        obj['inapp_registration'],
                                        obj['external_registration_link']
                                        // obj['attachment_base_url'],
                                        // obj['attachment_file_names']
                                    ));
                                });
                            }
                            SetPastEvents([..._pastEvents]);
                        } else {
                            console.log('FetchLatestPastEvents: ' + JSON.stringify(res));
                        }
                        break;
                    case 'fetchCurrentNewsletters':
                        if (!JSON.stringify(res).includes('_false')) {
                            const _newsletters = [] as Document[];
                            const _newslettersYears = [] as string[];
                            let resObjs = [] as any[];
                            try {
                                resObjs = JSON.parse(res) as any[];
                            } catch {
                                resObjs = res as any[];
                            }
                            if (resObjs.length > 0) {
                                resObjs.map((obj: any) => {
                                    let yearExist = false;
                                    _newslettersYears.map((year: string) => {
                                        if (IonDate(obj['datetime_created']).getFullYear().toString() == year)
                                            yearExist = true;
                                    });
                                    if (!yearExist)
                                        _newslettersYears.push(IonDate(obj['datetime_created']).getFullYear().toString());

                                    _newsletters.push(new Document(
                                        obj['documentID'],
                                        obj['document_cateogryID'],
                                        obj['label'],
                                        obj['description'],
                                        obj['poster_url'],
                                        obj['file_url'],
                                        obj['extra_url'],
                                        obj['viewable_member_typeIDs'],
                                        obj['viewable_member_user_types'],
                                        obj['viewable_committee_typeIDs'],
                                        obj['creator_userID'],
                                        obj['datetime_created'],
                                        obj['datetime_expired'],
                                        obj['updater_userID'],
                                        obj['datetime_updated']
                                    ));
                                });
                            }
                            SetNewslettersYears([..._newslettersYears]);
                            SetNewsletters([..._newsletters]);
                        } else {
                            console.log('fetchCurrentNewslettersErr: ' + res);
                        }
                        break;
                }
            }

            switch (appContext.databaseActionModeQueue[0]) {
                case 'fetchHighlightProfiles':
                case 'fetchUpcomingEvents':
                case 'fetchLatestPastEvents':
                case 'fetchCurrentNewsletters':
                    ExecuteDatabaseResultAction();
                    break;
            }
        }
    }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);

    //ui functions
    const OnEventNavBtnClicked = (mode: string, event: Event) => {
        switch (mode) {
            case 'current':
            case 'past':
                if (exAppContext.viewMode == App_ViewModeMap.MEMBER) {
                    history.push('/Events/' + (mode == 'current' ? Events_PageMap.UPCOMING : Events_PageMap.PAST) + '/' + event.eventID);
                }
                else
                    history.push('/ViewEventGallery/Committee/' + event.eventID);
                break;
            case 'myevent':
                history.push('/MyEvents/0/' + event.eventID);
                break;
        }
    }
    // const OnMyEventNavClicked = () => {
    //     const selectedEvent = exAppContext.userUpcomingEvents[navigatedEventIndexRef.current];
    //     // exAppContext.SetCurrentSelectedEvent(selectedEvent); ---deprecated
    //     history.push('/MyEvents/0/' + selectedEvent.eventID);
    // } --deprecated

    //exe functions
    // const CheckEventRegistrationIsOngoing = (event: Event) => {
    //     const now = new Date();
    //     if (
    //         event.registration_start_date! && event.registration_end_date! &&
    //         now >= event.registration_start_date && now <= event.registration_end_date
    //     )
    //         return true;
    //     else
    //         return false;
    // } ---deprecated of unused

    //render functions
    const RenderMyEventCard = (event: Event, i: number, mode: string) => {
        return (
            <button className='event-nav-card' onClick={() => OnEventNavBtnClicked(mode, event)} key={'event-nav-btn-' + i}>
                {
                    myEventsAltImgs[i] != undefined && myEventsAltImgs[i].length == 0 ?
                        <img className='event-nav-card-img' src={event.event_poster} onError={() => {
                            setTimeout(() => {
                                myEventsAltImgsRef.current[i] = DefaultImage;
                                SetMyEventsAltImgs([...myEventsAltImgsRef.current]);
                            }, 100);
                        }} />
                        :
                        <img className='event-nav-card-img ex' src={myEventsAltImgs[i]} />
                }
                <div className='event-nav-card-row'>
                    <span className='event-nav-card-title'>{event.event_name}</span>
                </div>
                <div className='event-nav-card-row'>
                    <LocationOnIcon />
                    <span className='event-nav-card-lbl'>{event.event_venue}</span>
                </div>
                <div className='event-nav-card-row ex'>
                    <span className='event-nav-card-lbl ex'>View Details</span>
                    <EastIcon className='svg' />
                </div>
            </button>
        )
    }
    const RenderEventNavCard = (event: Event, i: number, mode: string) => {
        return (
            <button className='event-nav-card' onClick={() => OnEventNavBtnClicked(mode, event)} key={'event-nav-btn-' + i}>
                {
                    mode == 'current' ?
                        upcomingEventsAltImgs[i] != undefined && upcomingEventsAltImgs[i].length == 0 ?
                            <img className='event-nav-card-img' src={event.event_poster} onError={() => {
                                setTimeout(() => {
                                    upcomingEventsAltImgsRef.current[i] = DefaultImage;
                                    SetUpcomingEventsAltImgs([...upcomingEventsAltImgsRef.current]);
                                }, 100);
                            }} />
                            :
                            <img className='event-nav-card-img ex' src={upcomingEventsAltImgs[i]} />
                        :
                        pastEventsAltImgs[i] != undefined && pastEventsAltImgs[i].length == 0 ?
                            <img className='event-nav-card-img' src={event.event_poster} onError={() => {
                                setTimeout(() => {
                                    pastEventsAltImgsRef.current[i] = DefaultImage;
                                    SetPastEventsAltImgs([...pastEventsAltImgsRef.current]);
                                }, 100);
                            }} />
                            :
                            <img className='event-nav-card-img ex' src={pastEventsAltImgs[i]} />
                }
                <div className='event-nav-card-row'>
                    <span className='event-nav-card-title'>{event.event_name}</span>
                </div>
                <div className='event-nav-card-row'>
                    <LocationOnIcon />
                    <span className='event-nav-card-lbl'>{event.event_venue}</span>
                </div>
                <div className='event-nav-card-row ex'>
                    <span className='event-nav-card-lbl ex'>
                        {/*mode == 'current' ?
                        (
                            exAppContext.viewMode == App_ViewModeMap.MEMBER ?
                                (
                                    IsEventRegistrationOpen(event) ?
                                    'Register Now'
                                    :
                                    'View Details'
                                )
                                :
                                (
                                    exAppContext.viewMode == App_ViewModeMap.COMMITTEE ?
                                        'Manage Gallery'
                                        :
                                        ''
                                )
                        ) : 'View Details' ---deprecated */}
                        {
                            exAppContext.viewMode == App_ViewModeMap.MEMBER ?
                                (
                                    mode == 'current' ?
                                        (
                                            IsEventRegistrationOpen(event) ?
                                                'Register Now'
                                                :
                                                'View Details'
                                        )
                                        :
                                        'View Details'
                                )
                                :
                                (
                                    exAppContext.viewMode == App_ViewModeMap.COMMITTEE ?
                                        'Manage Gallery'
                                        :
                                        ''
                                )
                        }
                    </span>
                    <EastIcon className='svg' />
                </div>
                {/* {
                    mode == 'current' ?
                        upcomingEventsAltImgs[i] != undefined && upcomingEventsAltImgs[i].length == 0 ?
                            <img className='event-nav-card-img' src={event.event_poster} onError={() => {
                                setTimeout(() => {
                                    upcomingEventsAltImgsRef.current[i] = PPKMLogo;
                                    SetUpcomingEventsAltImgs([...upcomingEventsAltImgsRef.current]);
                                }, 100);
                            }} />
                            :
                            <img className='event-nav-card-img' src={upcomingEventsAltImgs[i]} />
                        :
                        pastEventsAltImgs[i] != undefined && pastEventsAltImgs[i].length == 0 ?
                            <img className='event-nav-card-img' src={event.event_poster} onError={() => {
                                setTimeout(() => {
                                    pastEventsAltImgsRef.current[i] = PPKMLogo;
                                    SetPastEventsAltImgs([...pastEventsAltImgsRef.current]);
                                }, 100);
                            }} />
                            :
                            <img className='event-nav-card-img' src={pastEventsAltImgs[i]} />
                }
                <div className='event-nav-card-col'>
                    <span className='event-nav-card-title'>{event.event_name}</span>
                    <span className='event-nav-card-lbl date'>{
                        IonDateString(event.event_start_datetime, IonDateFormat.MALAYSIA_STANDARD_DATE)
                        + ' - '
                        + IonDateString(event.event_end_datetime, IonDateFormat.MALAYSIA_STANDARD_DATE)
                    }</span>
                    <span className='event-nav-card-lbl venue'>at {event.event_venue}</span>
                    <span className='event-nav-card-lbl ex'>{
                        exAppContext.viewMode == App_ViewModeMap.MEMBER ?
                            mode == 'current' ? 'Register Now' : 'View Details'
                            :
                            (
                                'Manage Gallery'
                            )
                    } <ArrowForwardIosIcon /></span>
                </div> */}
            </button>
        )
    }
    const RenderNewsletterCard = (newsletter: Document, i: number) => {
        const newsletterAltImgSrc = GetNewsletterAltImgByDocumentID(newsletter.documentID);
        return (
            <div className='newsletter-card' key={'newsletter-card-' + i} onClick={async () => { await Browser.open({ url: newsletter.file_url }); }}>
                {
                    newsletterAltImgSrc != undefined && newsletterAltImgSrc.length == 0 ?
                        <img className='newsletter-card-img' src={newsletter.poster_url} onError={() => {
                            setTimeout(() => {
                                newslettersAltImgsRef.current.map((newsletterAltImg: NewsletterImgMap, j: number) => {
                                    if (newsletter.documentID == newsletterAltImg.documentID)
                                        newslettersAltImgsRef.current[j] = { documentID: newsletter.documentID, src: DefaultImage } as NewsletterImgMap;
                                });
                                SetNewslettersAltImgs([...newslettersAltImgsRef.current]);
                            }, 100);
                        }} />
                        :
                        <img className='newsletter-card-img' src={newsletterAltImgSrc} />
                }
                <span className='newsletter-card-lbl'>{newsletter.label}</span>
            </div>
        )
    }

    //exe function
    const FilterEventIsOngoing = (events: Event[]) => {
        const res = [] as Event[];
        const now = new Date();
        events.map((event: Event) => {
            if (
                /*event.registration_start_date! && event.registration_end_date!
                now >= event.registration_start_date && now <= event.registration_end_date --modify this checking*/
                event.event_end_date != null && now <= event.event_end_date
            ) {
                res.push(event);
            }
        });
        return res;
    }
    const FilterNewslettersByYear = (newsletters: Document[], year: string) => {
        const res = [] as Document[];
        newsletters.map((newsletter: Document) => {
            if (
                newsletter.datetime_created != null
                && newsletter.datetime_created.getFullYear().toString() == year
            )
                res.push(newsletter);
        })
        return res;
    }
    const GetNewsletterAltImgByDocumentID = (documentID: string) => {
        let res = '';
        if (newslettersAltImgsRef.current.length > 0) {
            newslettersAltImgsRef.current.map((newsletterAltImg: NewsletterImgMap) => {
                if (newsletterAltImg.documentID == documentID)
                    res = newsletterAltImg.src;
            });
        }
        return res;
    }
    const FetchAndShowNotices = () => {
        const formData = new FormData();
        formData.append("getAllNotices", "true");

        axios.post("https://www.ppkm.org.my/mobile_backend/assets/notices/index.php", formData, { withCredentials: false }).then((res: any) => {
            let resObjs = [];
            try {
                resObjs = JSON.parse(res.data) as any[];
            } catch {
                resObjs = res.data as any[];
            }
            const _notices: Notice[] = [];
            resObjs.map((resObj: any) => {
                _notices.push(new Notice(resObj['url'], resObj['action']));
            });
            SetNotices([..._notices]);
        }).catch((err: any) => {
            elog('GetAllNoticesErr: ' + err);
        });
    }

    //check functions
    const IsEventRegistrationOpen = (event: Event) => {
        const now = new Date();

        if (
            event.registration_start_date != null && event.registration_end_date != null
            && event.registration_start_date <= now && event.registration_end_date >= now
        ) {
            return true;
        } else
            return false;
    }

    return (
        <div className={'MemberHome ' + (appContext.deviceOrientation ? 'landscape' : 'portrait')} style={{ transform: `translateY(${topMargin}px)` }}>
            <div className='MemberHome-scroll-container' ref={homeScrollerRef}>
                {/** highlights section */}
                <div className='row'>
                    <div className='highlights-panel'><SlideProjector slides={highlights} autoSlide={4000} switchMode='slide' hideSubNav={true} hideMainNav={appContext.deviceOrientation == System_DeviceOrientationMap.PORTRAIT ? true : false} /></div>
                </div>
                {/** memberships row */}
                {
                    exAppContext.viewMode == App_ViewModeMap.MEMBER && exAppContext.userUpcomingEvents.length > 0 ?
                        <div className='row'>
                            <div className='events-panel'>
                                <div className='row ex'>
                                    <span className='events-panel-title'>My Event(s)</span>
                                </div>
                                <div className='events-panel-scroll-container'>
                                    {
                                        exAppContext.userUpcomingEvents.map((event: Event, i: number) => {
                                            return RenderMyEventCard(event, i, 'myevent');
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                        :
                        null
                }
                {/** upcoming events section */}
                {
                    FilterEventIsOngoing(upcomingEvents).length > 0 ?
                        <div className='row'>
                            <div className='events-panel'>
                                <div className='row ex'>
                                    <span className='events-panel-title'>Current Event(s)</span>
                                    <button className='view-more-nav-btn' onClick={() => history.push('/Events/' + Events_PageMap.UPCOMING)}>view more</button>
                                </div>
                                <div className='events-panel-scroll-container'>
                                    {
                                        FilterEventIsOngoing(upcomingEvents).map((event: Event, i: number) => {
                                            return RenderEventNavCard(event, i, 'current')
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                        :
                        null
                }
                {/** past events section */}
                {
                    (
                        pastEvents.length > 0 ?
                            <div className='row'>
                                <div className='events-panel'>
                                    <div className='row ex'>
                                        <span className='events-panel-title'>Past Event(s)</span>
                                        <button className='view-more-nav-btn' onClick={() => history.push('/Events/' + Events_PageMap.PAST)}>view more</button>
                                    </div>
                                    <div className='events-panel-scroll-container'>
                                        {
                                            pastEvents.map((event: Event, i: number) => {
                                                return (
                                                    RenderEventNavCard(event, i, 'past')
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    )
                }
                {/**News Letter sections */}
                <div className='row ex'>
                    <div className='newsletters-panel'>
                        <span className='newsletters-panel-title'>Newsletter(s)</span>
                    </div>
                </div>
                {
                    newslettersYears.map((year: string, i: number) => {
                        return (
                            <div className='row' key={'row-' + i}>
                                <div className='newsletters-panel'>
                                    <div className='row ex'>
                                        <span className='newsletters-panel-title ex'>{year}</span>
                                        <button className='view-more-nav-btn' onClick={() => { history.push('/ViewDocuments/Newsletter'); }}>view more</button>
                                    </div>
                                    <div className='newsletters-panel-scroll-container'>
                                        {
                                            FilterNewslettersByYear(newsletters, year).map((newsletter: Document, i: number) => {
                                                return RenderNewsletterCard(newsletter, i)
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            <SwipeOverscrollHandler targetRef={homeScrollerRef} action={() => {
                setTimeout(() => { history.push('/Home') }, 100);
                history.push('/Blank')
            }} />
            {
                (appContext.shouldShowNotices && notices.length > 0)?
                <NoticeBoard notices={notices} SetNoticeBoardShouldShow={appContext.SetShouldShowNotices}/>
                :
                null
            }
        </div>
    );
}

export default MemberHome;